import { Row, Col } from "antd";
import React, { Component } from "react";
import "./dashboard.css"
import { connect } from "react-redux";
import { DashboardAction, UserAction } from "../../store/actions";
import { MdUpload } from "react-icons/all";
class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: {
        order: "asc",
        page: 1,
        column: "name",
        status: "pending",
        search: "",
        totalCount: 0,
        currentCount: 0,
        total_pages: 0,
        start_date: "",
        end_date: "",
        period: "",
      },
      onShowProfileIcon: true
    };
  }
  componentDidMount() {
    const { getCompanyDetails } = this.props;
    getCompanyDetails();
  }

  render() {
    const { contractorDetail } = this.props;
    const { onShowProfileIcon } = this.state;
    let inputRef;

    return (
      <Row justify="space-between">
        <Col
          xl={24}
          sm={24}
          xs={24}
          lg={24}
          md={24}
          style={{
            minHeight: "350px",
            background: "white",
            marginTop: "22px",
            boxShadow: "0px 0px 5px 0px rgb(0 0 0 / 16%)",
            border: "solid 1px #f7f7f7",
            padding: "1rem",
          }}
        >
          <Row
            justify="space-between"
            className="m-auto"
            style={{ padding: "1%" }}
            align="top"
          >
            <Col xl={12} lg={12} xs={24} md={24} sm={24}>
              <h2
                style={{ marginTop: "-15px", marginBottom: "10px" }}
                className="text-left"
              >
                Account Dashboard
              </h2>
              <h4
                className="text-left"
                style={{ fontWeight: "500", fontSize: "14px" }}
              >
                {`Hello, ${contractorDetail?.user?.first_name} ${contractorDetail?.user?.last_name}!`}
              </h4>

              <Row>
                <Col span={24} className="text-left">
                  <p
                    className="text-left"
                    style={{ marginTop: "10px", marginBottom: "10px" }}
                  >
                    From your account dashboard you have the ability to view a
                    snapshot of your recent account activity and update your account
                    information. Select a link below to view or edit information.
                  </p>
                </Col>
              </Row>
              <Row>
                <Col xl={10} lg={10} xs={24} md={24} style={{ marginTop: '15px' }}>
                  <span
                    style={{ fontWeight: "bold" }}
                    className="d-block text-left"
                  >
                    Contact Information
                  </span>
                  <span className="d-block text-left">{`${contractorDetail?.user?.first_name} ${contractorDetail?.user?.last_name}`}</span>
                  <span className="d-block text-left">
                    {`${contractorDetail?.user?.email}`}
                  </span>
                  <span className="d-block text-left">
                    {" "}
                    {`${contractorDetail?.user?.phone}`}
                  </span>
                </Col>
              </Row>
            </Col>
            <Row justify="space-between" className="pointer-cursor" >
              <div xl={12} lg={12} xs={12} md={12} class="customer-container">
                <img
                  src={contractorDetail?.user?.image?.original}
                  class="customer-profile-image"
                  onClick={() => inputRef.click()}
                />
                <div class="customer-profile-align-middle">
                  <div class="customer-profile-icon" >
                    <MdUpload size="25" onClick={() => inputRef.click()} />
                  </div>
                </div>
              </div>
            </Row>
            <input
              type={"file"}
              className="d-none"
              ref={(ref) => (inputRef = ref)}
              onChange={(e) =>
                this.props.updateCompanyDetails({ image: e.target.files[0] })
              }
            />
          </Row>
        </Col>
      </Row>
    );
  }
}
function mapStateToProps(store) {
  return {
    counts: store.DashboardReducer.orderCount,
    Orders: store.DashboardReducer.orders,
    user: store.AuthReducer.user,
    metaData: store.DashboardReducer.metaData,
    loading: store.DashboardReducer.isLodadingCount,
    isLoader: store.DashboardReducer.isOrder,
    contractorDetail: store.UserReducer.companyDetails,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    getCounts: (id) => dispatch(DashboardAction.getCountReq(id)),
    getOrders: (id, params) =>
      dispatch(DashboardAction.getOrderReq(id, params)),
    getUserDetails: (id) => dispatch(UserAction.getUserDetailReq(id)),
    getCompanyDetails: () => dispatch(UserAction.getCompantDetailReq()),
    updateCompanyDetails: (payload) =>
      dispatch(UserAction.updateBusinessInfoReq(payload)),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
